import styled from 'styled-components';
import tw from 'twin.macro';

const Separator = styled.div`
    ${tw`w-full py-px my-2 rounded-lg bg-gray-200`}
`;

export default Separator;